export default __webpack_public_path__ + "assets/9fb71b26b46f0f4598717f7e35c8a10d.png";